
import TiwiMixin from '../../mixins/TiwiMixin';
import StoryEditorBlock from './StoryEditorBlock'
import ModalPopup from '../ModalPopup';
import Draggable from 'vuedraggable'
import Multiselect from 'vue-multiselect'

export default {
  mixins: [TiwiMixin],
  components: {
    StoryEditorBlock,
    Draggable,
    Multiselect,
    ModalPopup
  },
  props: {
    storyId: {
      required: false,
      default: false,
      type: Number
    },
  },
  data() {
    return {
      cover_loading: false,
      attach_loading: false,
      prevent_leave: false,
      showDeleteModal: false,
      blocks: [],
      story: {},
      available_tags: [],
      available_colls: [],
      available_topics: [],
      new_collection: false,
      selected_collection: null,
      selected_topic: null,
      sticky_until: null,
      block_error: null
    }
  },
  computed: {
    cover() {
      return this.story?.fields?.cover;
    },
    attachments() {
      return this.story?.fields?.file_allegati?.map((attach) => ({ id: attach.allegato.ID, name: attach.allegato.filename, url: attach.allegato.url }));
    }
  },
  mounted: function () {
    this.loadStory();

    this.findAvailableTags();
    this.loadCollections();
    this.loadTopics();

    window.addEventListener('beforeunload', (event) => {
      if (this.prevent_leave) {
        event.preventDefault();
      }
    });
  },
  methods: {
    loadStory: function () {
      const self = this;

      self.setLoading(true);

      this.api.post('story-editor/load', { story_id: this.storyId })
        .then((response) => {
          if (response.data.success) {
            self.blocks = response.data.blocks.map((block, i) => {
              block.block_id = `${response.data.story.ID}b${i}`;
              block.updated = true;
              return block;
            });
            self.story = response.data.story;

            if (!self.story?.fields?.file_allegati) {
              if (!self.story.fields) {
                self.story.fields = { file_allegati: [] };
              } else {
                self.story.fields.file_allegati = [];
              }
            }

            if (!self.story?.fields?.cover) {
              self.story.fields.cover = { desktop: {}, mobile: {} };
            } else {
              self.story.cover_id = self.story.fields.cover.desktop.ID;
            }

            if (self.story?.fields?.collection) {
              self.selected_collection = self.story?.fields?.collection?.term_id;
            }

            if (self.story?.fields?.topic) {
              self.selected_topic = self.story?.fields?.topic?.term_id;
            }

            if (self.story?.fields?.sticky_until) {
              self.sticky_until = self.story?.fields?.sticky_until;
            }

            self.prevent_leave = false;
            self.new_collection = false;
            self.loadCollections();
          } else {
            self.toast.error(response.data.message);
          }
        })
        .catch((error) => {
          self.toast.error('Errore durante il caricamento della storia');
          console.log(error);
        })
        .finally(() => self.setLoading(false))
    },
    publishStory: function (isDraft = false, autosave = false) {
      // console.log('publish', this.blocks);
      const self = this;

      if (!autosave && this.blocks.flat().length == 0) {
        self.toast.error('Nessun contenuto aggiunto. La storia è vuota.');
        return;
      }

      self.setLoading(true);

      this.api.post('story-editor/save', {
        blocks: this.blocks,
        story_id: this.storyId,
        story_title: this.story.post_title,
        cover_image_id: this.story.cover_id,
        tags: this.story.tags,
        attachments: this.story?.fields?.file_allegati?.map((attach) => attach.allegato.ID),
        collection: this.selected_collection,
        topic: this.selected_topic,
        sticky_until: this.sticky_until,
        is_draft: isDraft,
        autosave: autosave
      })
        .then((response) => {
          if (!autosave) {
            if (response.data.success) {
              self.toast.success(isDraft ? 'Bozza storia aggiornata' : 'Storia pubblicata');
              self.block_error = null;

              // Let's goooo
              if (!isDraft) {
                window.setTimeout(function () {
                  window.location.href = response.data.story_url;
                }, 1500);
              } else {
                this.loadStory();
              }

              this.prevent_leave = false;
            } else {
              self.toast.error(response.data.message);
              self.block_error = response.data.block_id;
            }
          }
        })
        .catch((error) => {
          if (!autosave) {
            self.toast.error('Errore nella richiesta');
          }
        })
        .finally(() => {
          self.setLoading(false);
        })
    },
    blockUpdate: function (block) {
      const id = this.blocks.findIndex(b => b.block_id === block.block_id);
      if (id) {
        this.blocks[id] = block;
      }

      this.prevent_leave = true;

      if (block.blockName === 'core/image') {
        this.publishStory(false, true);
      }
    },
    blockDelete: function (block) {
      const id = this.blocks.findIndex(b => b.block_id === block.block_id);

      if (id || id === 0) {
        // delete this.blocks[id];
        this.blocks.splice(id, 1);
      }

      this.prevent_leave = true;

      if (block.blockName === 'core/image') {
        this.publishStory(false, true);
        // this.uploadMedia(null, block.attrs.id);
        this.api.post('media/delete', { delete_media: block.attrs.id });
      }
    },
    addTextBlock: function () {
      this.blocks.push({ blockName: 'core/paragraph', block_id: `${this.story.ID}b${this.blocks.length}`, newBlock: true, updated: true });
    },
    addImageBlock: function () {
      this.blocks.push({ blockName: 'core/image', block_id: `${this.story.ID}b${this.blocks.length}`, newBlock: true, updated: true });
    },
    onDragEnd: function (param) {
      // Questa roba ricarica il blocco per ri-inizializzare tinymce
      const self = this;
      this.blocks[param.newIndex].updated = false;
      this.blocks[param.oldIndex].updated = false;

      this.$nextTick(() => {
        self.blocks[param.newIndex].updated = true;
        self.blocks[param.oldIndex].updated = true;
      });

      this.prevent_leave = true;
    },
    handleFileChange: function (e) {
      const selected_image = e.target.files[0];
      const self = this;

      self.cover_loading = true;

      this.uploadMedia(selected_image, (response) => {
        self.story.cover_id = response.data.media_id;

        self.cover_loading = false;
        self.story.fields.cover.mobile.url = response.data.attachment_url;
        self.story.fields.cover.desktop.url = response.data.attachment_url;

        this.prevent_leave = true;
      }, () => {
        self.toast.error('Immagine non caricata: la dimensione massima è di ' + this.config.max_upload_size)
      }, () => {
        self.cover_loading = false;
        this.publishStory(false, true);
      }, self.story.cover_id);
    },
    addTag(newTag) {
      if (this.story.tags.length > 12) {
        this.toast.error('Non è possibile aggiungere altri tag!');
        return;
      }
      newTag = newTag.replace(/[^\p{L}\p{N}-]/giu, '').toLowerCase();
      this.story.tags.push(newTag);
      this.prevent_leave = true;
    },
    findAvailableTags(query = '') {
      this.isLoading = true;
      this.api.post('tax-query/find', { taxonomy: 'tags', keyword: query })
        .then((response) => {
          if (response.data.success) {
            this.available_tags = response.data.terms;
          }
        })
    },
    loadCollections() {
      this.isLoading = true;
      this.api.post('tax-query/find', { taxonomy: 'collection', pluck: 0 })
        .then((response) => {
          if (response.data.success) {
            this.available_colls = response.data.terms;
          }
        })
    },
    loadTopics() {
      this.isLoading = true;
      this.api.post('tax-query/find', { taxonomy: 'topic', pluck: 0 })
        .then((response) => {
          if (response.data.success) {
            this.available_topics = response.data.terms;
          }
        })
    },
    removeAttachment(attach) {
      const attIndex = this.story?.fields?.file_allegati.findIndex((a) => a.allegato.ID === attach.id);
      if (attIndex !== undefined) {
        this.prevent_leave = true;
        this.story.fields.file_allegati.splice(attIndex, 1);

        this.api.post('media/delete', { delete_media: attach.id });
        this.publishStory(false, true);
      }
    },
    uploadAttachment(e) {
      const self = this;
      this.attach_loading = true;
      this.prevent_leave = true;
      this.uploadMedia(e.target.files[0], function (response) {
        self.story.fields.file_allegati.push({
          nome_allegato: response.data.attachment.name,
          allegato: response.data.attachment
        });
        self.attach_loading = false;

        self.publishStory(false, true);
      }, function () {
        self.toast.error('Errore durante il caricamento. Allegato non caricato.');
        self.attach_loading = false;
      });
    },
    onCloseDeleteModal() {
      this.showDeleteModal = false;
    },
    deleteStory(confirm = false) {
      this.showDeleteModal = true;

      if (confirm) {
        const self = this;

        self.setLoading(true);

        this.api.post('story-editor/delete', { story_id: this.storyId })
          .then((response) => {
            if (response.data.success) {
              self.toast.success('La storia è stata eliminata.');

              window.setTimeout(function () {
                window.location.href = self.config.pages.user_profile;
              }, 1500);
            } else {
              self.toast.error('Errore. La storia non è stata eliminata.');
            }
            self.setLoading(false);
          })
      }
    }
  }
}
